import { toast } from "sonner";
import { Phone } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { useApi, Skeleton, badge } from "@/components/portal/ui";
import { AdminTitle } from "@/pages/admin/AdminLayout";

const TONE = { baru: badge.warn, diproses: badge.info, selesai: badge.success };

export default function Pastoral() {
  const { data, reload } = useApi("/admin/pastoral");
  const setStatus = async (p, status) => {
    await api.patch(`/admin/pastoral/${p.id}`, { status });
    toast.success(`Status: ${status}`);
    reload();
  };
  return (
    <div data-testid="admin-pastoral">
      <AdminTitle eyebrow="Pelayanan" title="Layanan Pastoral" />
      {!data ? <Skeleton className="h-80" /> : (
        <div className="grid md:grid-cols-2 gap-4">
          {data.length === 0 && <p className="text-slate-500">Belum ada permohonan.</p>}
          {data.map((p) => (
            <div key={p.id} className="bg-white rounded-3xl p-6 shadow-sm border border-slate-100" data-testid={`pastoral-${p.id}`}>
              <div className="flex items-center justify-between">
                <span className="flex gap-1.5"><span className="text-[11px] font-bold bg-blue-100 text-blue-700 rounded-full px-3 py-1">{p.type}</span>{p.source === "portal" && <span className="text-[11px] font-bold bg-slate-100 text-slate-700 rounded-full px-3 py-1">Portal · NIG {p.nig}</span>}{p.confidential && <span className="text-[11px] font-bold bg-red-50 text-red-600 rounded-full px-3 py-1">Rahasia</span>}</span>
                <span className={`text-[11px] font-bold rounded-full px-3 py-1 ${TONE[p.status] || badge.info}`}>{p.status}</span>
              </div>
              <p className="mt-4 font-extrabold text-slate-900">{p.name}</p>
              <p className="text-sm text-slate-500 flex items-center gap-1.5"><Phone className="w-3.5 h-3.5" />{p.phone} · {fmtDate(p.created_at, { day: "numeric", month: "short" })}</p>
              <p className="mt-3 text-sm text-slate-600 leading-relaxed">{p.message}</p>
              <div className="mt-5 flex gap-2">
                {["diproses", "selesai"].map((s) => (
                  <button key={s} disabled={p.status === s} onClick={() => setStatus(p, s)} data-testid={`pastoral-${s}-${p.id}`} className="flex-1 border border-slate-200 rounded-xl py-2.5 text-sm font-bold text-slate-700 hover:bg-slate-50 disabled:opacity-40 capitalize">{s}</button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
